import pageNotFound from './pageNotFound'

export default {
  '404Page': pageNotFound
}
